





























import { computed, defineComponent } from '@vue/composition-api';
import { useResultStore } from './store';
import { useApi } from '@/util/useApi';
import { getResults, Result } from './api';
import Recommend from '@/components/Recommend.vue';
import VClamp from 'vue-clamp';
import ResultCard from '@/components/ResultCard.vue';
import { isString } from 'lodash';

export default defineComponent({
  components: { VClamp, Recommend, ResultCard },
  setup(_, { root }) {
    const { setCurrent } = useResultStore();

    const keyword = computed(() => root.$route.query.keyword as string);

    const { result, refresh } = useApi(async (page = 1) => {
      if (isString(keyword.value)) {
        const res = await getResults({ page: 1, size: 20 });
        const all = res.data.result.filter(
          p =>
            p.title.includes(keyword.value) ||
            p.tsDetail.includes(keyword.value) ||
            p.tsResult.includes(keyword.value),
        );
        res.data.result = all.slice((page - 1) * 15, page * 15);
        res.data.total = all.length;
        return res;
      } else {
        return await getResults({ page, size: 15 });
      }
    });

    return {
      total: computed(() => (result.value ? result.value.data.total : 0)),
      results: computed(() => (result.value ? result.value.data.result : [])),
      toDetail(item: Result) {
        setCurrent(item);
        root.$router.push({ name: 'ResultDetail' });
      },
      onPageChange: (page: number) => {
        refresh(page);
      },
    };
  },
});
